/**
 * 追加css class
 */

export function addClass(element, name) {
  var oldList = classList(element),
    newList = oldList + name;

  if (hasClass(oldList, name)) return;

  // Trim the opening space.
  element.className = newList.substring(1);
}

/**
 * 移除css class
 */

export function removeClass(element, name) {
  var oldList = classList(element),
    newList;

  if (!hasClass(element, name)) return;

  // Replace the class name.
  newList = oldList.replace(' ' + name + ' ', ' ');

  // Trim the opening and closing spaces.
  element.className = newList.substring(1, newList.length - 1);
}
/**
 * 是否含有特定class
 */

function hasClass(element, name) {
  var list = typeof element == 'string' ? element : classList(element);
  return list.indexOf(' ' + name + ' ') >= 0;
}
/**
 * 元素所有class
 */

function classList(element) {
  return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
}

/**
 * Removes an element from the DOM.
 */

export function removeElement(element) {
  element && element.parentNode && element.parentNode.removeChild(element);
}

/**
 * css class切换
 * @param {*} obj
 * @param {*} cls
 */
export function toggleClass(obj, cls) {
    if (hasClass(obj, cls)) {
        removeClass(obj, cls);
    } else {
        addClass(obj, cls);
    }
}

/**
 * 字符串换行处理
 */
export function stringDivider(str, width, spaceReplacer) {
    if (!str) {
        return '';
    }
    if (str.length > width) {
        var p = width;
        while (p > 0 && (str[p] != ' ' && str[p] != '-')) {
            p--;
        }
        if (p > 0) {
            var left;
            if (str.substring(p, p + 1) == '-') {
                left = str.substring(0, p + 1);
            } else {
                left = str.substring(0, p);
            }
            var right = str.substring(p + 1);
            return left + spaceReplacer + stringDivider(right, width, spaceReplacer);
        }
    }
    return str;
}

/**
 * localstorage 储存对象
 * @param {*} key
 * @param {*} obj 对象
 */
export function localstorageSet(key, obj) {
    if (obj) {
        var save = JSON.stringify(obj);
        localStorage.setItem(key, save);
    }
}

/**
 * localstorage 获取对象
 * @param {*} key
 */
export function localstorageGet(key) {
    var out = null;
    if (key) {
        var data = localStorage.getItem(key);
        if (data) {
            out = JSON.parse(data);
        }
    }
    return out;
}

/**
 * 将度转换成为度分秒(返回字符串格式)
 * @param value 经纬度数值
 * @param type 0：经度，1：纬度
 * @param format 格式：ddd.dddddd°、ddd°mm.mmm′、ddd°mm′ss.ss″
 * @returns {string}
 */
export function formatDegree(value, type, format) {
    var output = '';
    var prefixs = type == 0 ? ['西', '东'] : ['南', '北'];
    var prefix = value < 0 ? prefixs[0] : prefixs[1];
    value = Math.abs(value);
    var v1 = Math.floor(value); //度
    var v2 = Math.floor((value - v1) * 60); //分
    var v3 = ((value - v1) * 3600 % 60).toFixed(2); //秒
    switch (format) {
        case 0:
            output = prefix + value.toFixed(6) + '°';
            break;
        case 1:
            output = prefix + v1 + '°' + ((value - v1) * 60).toFixed(3) + '′';
            break;
        case 2:
            output = prefix + v1 + '°' + v2 + '′' + v3 + '″';
            break;
    }
    return output;
}

/**
 * 产生一个id
 */
export function newId() {
    var mydate = new Date();
    var result = mydate.getFullYear().toString() + (mydate.getMonth() + 1).toString() + mydate.getDate().toString() +
        mydate.getHours().toString() + mydate.getMinutes().toString() + mydate.getSeconds().toString() + mydate.getMilliseconds().toString();
    return result;
}

/*
* 设置元素css
* */
export function setEleCss(obj, css) {
  for (const attr in css) {
    obj.style[attr] = css[attr];
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js